/** biome-ignore-all lint/correctness/useUniqueElementIds: <explanation> */
import type React from 'react';

export interface ToggleOffThumbIconProps {
	width?: string | number;
	height?: string | number;
	fill?: string;
	'aria-label'?: string;
}

const ToggleOffThumbIcon: React.FC<ToggleOffThumbIconProps> = ({
	width = 25,
	height = 24,
	fill = 'currentColor',
	'aria-label': ariaLabel = 'Toggle Off Thumb Icon',
}) => {
	return (
		<svg
			width={width}
			height={height}
			viewBox="0 0 25 24"
			fill={fill}
			aria-label={ariaLabel}
			xmlns="http://www.w3.org/2000/svg"
		>
			<title>Toggle Off Thumb Icon</title>
			<rect
				x="0.740234"
				width="24"
				height="24"
				rx="12"
				fill="url(#paint0_linear_2987_20388)"
			/>
			<g clipPath="url(#clip0_2987_20388)">
				<path
					d="M18.3281 17.2482L18.9356 17.8192C19.0228 17.7262 19.0876 17.6145 19.1249 17.4926C19.1621 17.3707 19.171 17.2419 19.1506 17.116C19.1303 16.9902 19.0814 16.8707 19.0077 16.7667C18.9339 16.6628 18.8373 16.5771 18.7252 16.5163L18.3281 17.2482ZM18.3275 6.98747L18.7258 7.72051C18.8379 7.6597 18.9346 7.57398 19.0084 7.46993C19.0821 7.36589 19.131 7.2463 19.1513 7.12038C19.1715 6.99446 19.1626 6.86557 19.1252 6.74364C19.0879 6.6217 19.023 6.50998 18.9356 6.41707L18.3275 6.98747ZM18.7252 16.5163C18.301 16.286 17.9124 15.9954 17.5715 15.6537L16.393 16.8322C16.8475 17.2874 17.3655 17.6744 17.9309 17.9812L18.7246 16.5157L18.7252 16.5163ZM17.5715 15.6537C16.6338 14.716 16.107 13.4442 16.107 12.1181C16.107 10.792 16.6338 9.52027 17.5715 8.58259L16.393 7.40408C15.1427 8.65432 14.4403 10.35 14.4403 12.1181C14.4403 13.8862 15.1427 15.5819 16.393 16.8322L17.5715 15.6537ZM17.5715 8.58259C17.9227 8.23139 18.3122 7.94442 18.7246 7.72051L17.9309 6.25503C17.3655 6.56184 16.8475 6.94886 16.393 7.40408L17.5715 8.58259ZM17.5715 7.40408C17.6221 7.45475 17.6722 7.50602 17.7205 7.55787L18.9356 6.41707C18.8747 6.35227 18.8128 6.28842 18.75 6.22556L17.5715 7.40408ZM8.14338 7.40408C9.39362 6.15383 11.0893 5.45145 12.8574 5.45145C14.6255 5.45145 16.3212 6.15383 17.5715 7.40408L18.75 6.22556C15.4955 2.97111 10.2193 2.97111 6.96487 6.22556L8.14338 7.40408ZM8.14338 16.8322C6.89313 15.5819 6.19076 13.8862 6.19076 12.1181C6.19076 10.35 6.89313 8.65432 8.14338 7.40408L6.96487 6.22556C3.71041 9.48002 3.71041 14.7562 6.96487 18.0107L8.14338 16.8322ZM17.5715 16.8322C16.3212 18.0824 14.6255 18.7848 12.8574 18.7848C11.0893 18.7848 9.39362 18.0824 8.14338 16.8322L6.96487 18.0107C10.2193 21.2651 15.4955 21.2651 18.75 18.0107L17.5715 16.8322ZM17.7205 16.6784C17.6722 16.7302 17.6221 16.7815 17.5715 16.8322L18.75 18.0107C18.813 17.9476 18.8749 17.8834 18.9356 17.8192L17.7205 16.6784Z"
					fill="white"
				/>
			</g>
			<defs>
				<linearGradient
					id="paint0_linear_2987_20388"
					x1="12.7402"
					y1="0"
					x2="12.7402"
					y2="24"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#195670" />
					<stop offset="1" stopColor="#117964" />
				</linearGradient>
				<clipPath id="clip0_2987_20388">
					<rect
						width="20"
						height="20"
						fill="white"
						transform="translate(2.74023 2)"
					/>
				</clipPath>
			</defs>
		</svg>
	);
};

export default ToggleOffThumbIcon;
